import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {QNA} from "../api";

export class QNAService extends RestService<QNA> {
    constructor(url: string) {
        if (url) {
            super(url)
        } else {
            super(REST_API_END_POINTS.QNA)
        }
    }
}
